module.exports = __webpack_public_path__ + "img/bigbilltut.168d0fe7.png";